// extracted by mini-css-extract-plugin
export var lg = "_2h-4";
export var md = "_2h-3";
export var sm = "_2h-2";
export var xs = "_2h-1";
export var xxs = "_2h-0";